import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import VersionUpdatePageComponent from './VersionUpdatePage';
import { getReleaseNotes, getReleasePdfUrl   } from '../../../store/actions/settings';
import { selectReleaseNotes, selectReleasePdfUrl   } from '../../../store/selectors/settings';
    

export const VersionUpdatePage = connect(
    () => {
        return (state, props) => ({
            getReleaseNotesPending: state.settings.getReleaseNotes.pending,
            getReleasePdfUrlPending: state.settings.getReleasePdfUrl.pending,
            releases: selectReleaseNotes(state),
            releasePdfUrl: selectReleasePdfUrl(state),
        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getReleaseNotes: getReleaseNotes,
            getReleasePdfUrl
        }, dispatch)
    })
)(injectIntl(VersionUpdatePageComponent));